import React from 'react';
import { Section } from './ui/Section';
export function Hero() {
  return <Section bg="bg-brand-sand" className="pt-20 md:pt-32 pb-16 md:pb-24" data-id="element-59">
      <div className="text-center space-y-6 md:space-y-8" data-id="element-60">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-brown leading-tight" data-id="element-61">
          Agrega ingresos para tu retiro después de los 50{' '}
          <span className="text-brand-terracotta block mt-2" data-id="element-62">
            (Sin títulos y sin estafas)
          </span>
        </h1>
        <h2 className="text-xl md:text-2xl text-brand-brown-light font-semibold max-w-2xl mx-auto leading-relaxed" data-id="element-63">
          El manual práctico para latinos en USA que no tienen ahorros
          suficientes y necesitan usar su celular para generar dinero real hoy
          mismo.
        </h2>
      </div>

      <div className="mt-12 flex justify-center" data-id="element-64">
        <a href="https://guiadownload.com/products/digital-product" target="_blank" rel="noopener noreferrer" data-id="element-65">
          <img src="https://cdn.magicpatterns.com/uploads/tyVr7SWMYSVwnmCnCTs7ZM/Agrega_(2).jpg" alt="Guía Digital Práctica - Agrega Ingresos para tu Retiro" className="w-full max-w-md rounded-2xl shadow-lg hover:shadow-xl transition-shadow cursor-pointer" data-id="element-66" />
        </a>
      </div>

      <div className="mt-12 bg-white p-6 md:p-10 rounded-2xl shadow-sm border border-brand-sand" data-id="element-67">
        <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-68">
          <strong className="font-bold text-brand-brown" data-id="element-69">
            Si vives en Estados Unidos, tienes más de 50 años y sientes que el
            tiempo se te vino encima sin haber ahorrado lo suficiente para el
            retiro, quiero decirte algo que nadie más te dirá: No estás solo y
            no es tu culpa.
          </strong>
        </p>
        <p className="text-lg md:text-xl leading-relaxed text-brand-brown-light" data-id="element-70">
          Pasaste décadas trabajando duro, pero el costo de vida subió, las
          leyes cambiaron y hoy te enfrentas a un mundo digital que parece
          ignorar tu experiencia. La buena noticia es que todavía tienes al
          menos 10 años de alta productividad por delante, y en este país, tu
          honestidad y tu palabra valen oro si sabes dónde ofrecerlas.
        </p>
      </div>
    </Section>;
}